<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <img :src="backIcon" @click="back" class="back" />
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <div class="label">
        <p class="text">
          {{ this.$store.getters.TRANSLATIONS["car_details"] }}
        </p>
      </div>
      <p class="content_title">
        {{ this.$store.getters.TRANSLATIONS["enter_your_car_details"] }}
      </p>
      <!-- <p class="label">Make</p> -->
      <div class="row">
        <div class="item">
          <div v-if="makeLoading">
            <pulse-loader
              :color="'#af7c00'"
              :size="'1em'"
              :loading="makeLoading"
            ></pulse-loader>
          </div>
          <select v-model="make" @change="onMakeChange" v-if="!makeLoading">
            <option
              v-for="item in makeList"
              v-bind:key="item.id_car_make"
              v-bind:value="item.name"
              :disabled="item.id_car_make === -1"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
        <!-- <p class="label">Model</p> -->
        <div class="item">
          <div v-if="modelLoading">
            <pulse-loader
              :color="'#af7c00'"
              :size="'1em'"
              :loading="modelLoading"
            ></pulse-loader>
          </div>
          <select v-model="model" v-if="!modelLoading">
            <option
              v-for="item in modelList"
              v-bind:key="item.id_car_model"
              v-bind:value="item.name"
              :disabled="item.id_car_model === -1"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="item">
          <!-- <p class="label">Type</p> -->
          <select v-model="type" class="type">
            <option
              v-for="item in typesList"
              v-bind:key="item.id"
              v-bind:value="item.name"
              :disabled="item.id === -1"
            >
              {{ item.name }}
            </option>
          </select>
        </div>
        <!-- <p class="label">Color</p> -->
        <div class="item">
          <div class="colorPicker">
            <select v-model="color" class="color colorPicker" ref="colorPicker">
              <option
                v-for="item in colorsList"
                v-bind:key="item.id"
                v-bind:value="item.name"
                :disabled="item.id === -1"
              >
                {{ item.name }}
              </option>
            </select>
            <div v-bind:style="{ background: this.color }"></div>
          </div>
        </div>
      </div>
      <!-- <p class="label">Plate number</p> -->
      <div class="row">
        <div class="item">
          <input
            type="text"
            v-model="plateNumber"
            :placeholder="this.$store.getters.TRANSLATIONS['plate_number']"
            class="plateNumber"
            autocomplete="off"
          />
          <!-- <p class="label">Year</p> -->
          <!-- <input
        type="tel"
        v-mask="'####'"
        v-model="year"
        placeholder="Year (Optional)"
        class="year"
        autocomplete="off"
          />-->
        </div>
        <div class="item">
          <select v-model="year" class="year">
            <option
              v-for="item in years"
              v-bind:key="item"
              v-bind:value="item"
              :disabled="item === 'Year (Optional)'"
            >
              {{ item }}
            </option>
          </select>
        </div>
      </div>
      <!-- <p class="label" v-if="doorjam">Doorjam code</p> -->
      <div class="row">
        <div class="item">
          <input
            v-if="doorjam"
            v-model="doorjam"
            v-on:click="addDoorJam()"
            class="doorjam"
            autocomplete="off"
          />
        </div>
        <div class="item">
          <!-- <button
            v-if="doorjam"
            v-on:click="addDoorJam()"
            class="button doorjam"
          >
            CHANGE
          </button>-->
        </div>
      </div>
      <div class="transmission">
        <p>{{ this.$store.getters.TRANSLATIONS["transmission"] }}</p>
        <toggle-switch
          :options="myOptions"
          :disabled="false"
          @change="updateMap($event.value)"
          class="transmission-radio"
        />
      </div>
    </div>
    <div class="footer" v-if="!loading">
      <button v-if="!doorjam" v-on:click="addDoorJam()" class="button doorjam">
        {{ this.$store.getters.TRANSLATIONS["add_doorjam"] }}
      </button>
      <button v-on:click="remove()" class="button remove">
        {{ this.$store.getters.TRANSLATIONS["delete"] }}
      </button>
      <button v-on:click="save()" class="button save">
        {{ this.$store.getters.TRANSLATIONS["save"] }}
      </button>
    </div>
    <v-dialog style="margin-top: 25%; text-align: center" :width="350" />
    <parkenda-toolbar v-if="!loading"></parkenda-toolbar>
  </div>
</template>

<script>
export default {
  beforeCreate() {
    const timeout = setTimeout(() => {
      this.makeLoading = true;
    }, 0);
    this.$http
      .get(`${process.env.SERVER_URL}/C2F09E97D5C747A5AA436F15B4A609D6`, {
        headers: {
          "x-access-token": this.$storage.get("parkendaToken")
        }
      })
      .then((response) => {
        console.log("Get car makes response:");
        console.log(response);
        if (response.data) {
          this.makeList = this.makeList.concat(response.data);
        } else {
          console.log("Can't get car makes from server");
        }
      })
      .then(() => {
        const make = this.makeList.find(
          (item) => item.name === this.$store.getters.USER.selectedCar.make
        );
        let id_car_make;
        if (make) {
          id_car_make = make.id_car_make;
          const timeout = setTimeout(() => {
            this.modelLoading = true;
          }, 0);
          this.$http
            .get(
              `${process.env.SERVER_URL}/495F432C95604408A000776AEB542571/${id_car_make}`,
              {
                headers: {
                  "x-access-token": this.$storage.get("parkendaToken")
                }
              }
            )
            .then((response) => {
              console.log("Get car models response:");
              console.log(response);
              if (response.data) {
                this.modelList = this.modelList.concat(response.data);
              } else {
                console.log("Can't get car models from server");
              }
            })
            .finally(() => {
              clearTimeout(timeout);
              this.modelLoading = false;
            });
        }
      })
      .catch((error) => {
        let text = this.$store.getters.TRANSLATIONS["something_went_wrong"];
        this.$modal.show("dialog", {
          text,
          buttons: [
            {
              title: "OK",
              handler: () => {
                this.$storage.remove("parkendaToken");
                this.$router.push("/login");
              }
            }
          ]
        });
      })
      .finally(() => {
        clearTimeout(timeout);
        this.makeLoading = false;
      });
  },
  created: function () {
    if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
      this.$router.push("/login");
    }
  },
  computed: {
    years() {
      const year = new Date().getFullYear();
      return [this.$store.getters.TRANSLATIONS["year_optional"]].concat(
        Array.from(
          { length: year - 1980 },
          (value, index) => 1981 + index
        ).reverse()
      );
    }
  },
  data() {
    return {
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      make: this.$store.getters.USER.selectedCar.make,
      model: this.$store.getters.USER.selectedCar.model,
      type: this.$store.getters.USER.selectedCar.type,
      makeList: [
        {
          name: this.$store.getters.TRANSLATIONS["select_car"],
          id_car_make: -1
        }
      ],
      modelList: [
        {
          name: this.$store.getters.TRANSLATIONS["select_model"],
          id_car_model: -1
        }
      ],
      typesList: [
        {
          name: this.$store.getters.TRANSLATIONS["select_type"],
          id: -1
        },
        {
          name: this.$store.getters.TRANSLATIONS["pickup_truck"],
          id: 1
        },
        {
          name: this.$store.getters.TRANSLATIONS["suv_full_size"],
          id: 2
        },
        {
          name: this.$store.getters.TRANSLATIONS["suv_mid_size"],
          id: 3
        },
        {
          name: this.$store.getters.TRANSLATIONS["sedan"],
          id: 4
        },
        {
          name: this.$store.getters.TRANSLATIONS["compact_car"],
          id: 5
        },
        {
          name: this.$store.getters.TRANSLATIONS["sport_exotic"],
          id: 6
        }
      ],
      colorsList: [
        {
          name: this.$store.getters.TRANSLATIONS["select_color"],
          id: -1
        },
        {
          name: this.$store.getters.TRANSLATIONS["white"],
          id: 1
        },
        {
          name: this.$store.getters.TRANSLATIONS["black"],
          id: 2
        },
        {
          name: this.$store.getters.TRANSLATIONS["red"],
          id: 3
        },
        {
          name: this.$store.getters.TRANSLATIONS["blue"],
          id: 4
        },
        {
          name: this.$store.getters.TRANSLATIONS["gray"],
          id: 5
        },
        {
          name: this.$store.getters.TRANSLATIONS["yellow"],
          id: 6
        },
        {
          name: this.$store.getters.TRANSLATIONS["green"],
          id: 7
        },
        {
          name: this.$store.getters.TRANSLATIONS["orange"],
          id: 8
        }
      ],
      color: this.$store.getters.USER.selectedCar.color.toLowerCase(),
      plateNumber: this.$store.getters.USER.selectedCar.licensePlate,
      year: this.$store.getters.USER.selectedCar.year,
      selectedTransmission: this.$store.getters.USER.selectedCar.flagIsManual
        ? this.$store.getters.TRANSLATIONS["manual"]
        : this.$store.getters.TRANSLATIONS["automatic"],
      doorjam: this.$store.getters.USER.selectedCar.doorjamCode,
      loading: false,
      makeLoading: false,
      modelLoading: false,
      backIcon: require("@/assets/new_design/Polygon_3.png"),
      updateMap: (selectedTransmission) => {
        this.selectedTransmission = selectedTransmission;
      },
      back: () => {
        this.$router.push("/carsList");
      },
      onMakeChange: () => {
        const make = this.makeList.find((item) => item.name === this.make);
        if (make) {
          this.model = this.$store.getters.TRANSLATIONS["select_model"];
          this.modelList = [
            {
              name: this.$store.getters.TRANSLATIONS["select_model"],
              id_car_model: -1
            }
          ];
          const id_car_make = make.id_car_make;
          const timeout = setTimeout(() => {
            this.modelLoading = true;
          }, 0);
          this.$http
            .get(
              `${process.env.SERVER_URL}/495F432C95604408A000776AEB542571/${id_car_make}`,
              {
                headers: {
                  "x-access-token": this.$storage.get("parkendaToken")
                }
              }
            )
            .then((response) => {
              console.log("Get car models response:");
              console.log(response);
              if (response.data) {
                this.modelList = this.modelList.concat(response.data);
              } else {
                console.log("Can't get car models from server");
              }
            })
            .catch((error) => {
              let text =
                this.$store.getters.TRANSLATIONS["something_went_wrong"];
              this.$modal.show("dialog", {
                text,
                buttons: [
                  {
                    title: "OK",
                    handler: () => {
                      this.$storage.remove("parkendaToken");
                      this.$router.push("/login");
                    }
                  }
                ]
              });
            })
            .finally(() => {
              clearTimeout(timeout);
              this.modelLoading = false;
            });
        }
      },
      save: () => {
        let error;
        if (
          !this.make ||
          this.make.length > 20 ||
          this.make === this.$store.getters.TRANSLATIONS["select_car"]
        ) {
          error = this.$store.getters.TRANSLATIONS["make_empty_max"];
        }
        if (
          !this.model ||
          this.model.length > 20 ||
          this.model === this.$store.getters.TRANSLATIONS["select_model"]
        ) {
          error = this.$store.getters.TRANSLATIONS["model_empty_max"];
        }
        if (!this.color || this.color.length > 20) {
          error = this.$store.getters.TRANSLATIONS["color_empty_max"];
        }
        if (!this.plateNumber || this.plateNumber.length > 20) {
          error = this.$store.getters.TRANSLATIONS["plate_number_empty_max"];
        }
        if (this.validateYear(this.year.toString())) {
          error = this.validateYear(this.year.toString());
        }
        if (
          !this.type ||
          this.type === this.$store.getters.TRANSLATIONS["select_type"]
        ) {
          error = this.$store.getters.TRANSLATIONS["type_empty_max"];
        }

        if (error) {
          this.$modal.show("dialog", {
            text: error,
            buttons: [
              {
                title: "OK"
              }
            ]
          });
        } else {
          const timeout = setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$http
            .post(
              `${process.env.SERVER_URL}/5DAF3A4ED84843908313629ADE010129`,
              {
                vehicleId: this.$store.getters.USER.selectedCar.id,
                make: this.make,
                model: this.model,
                type: this.type,
                color: this.color,
                licensePlate: this.plateNumber,
                year: this.year,
                flagIsManual:
                  this.selectedTransmission ===
                  this.$store.getters.TRANSLATIONS["automatic"]
                    ? "0"
                    : "1"
              },
              {
                headers: {
                  "x-access-token": this.$storage.get("parkendaToken")
                }
              }
            )
            .then((response) => {
              console.log("Edit car response");
              console.log(response);
              this.$router.push("/carsList");
            })
            .catch((error) => {
              let text =
                this.$store.getters.TRANSLATIONS["something_went_wrong"];
              if (
                error.response &&
                error.response.data &&
                error.response.data.error
              ) {
                text = error.response.data.error;
              }
              this.$modal.show("dialog", {
                text,
                buttons: [
                  {
                    title: "OK"
                  }
                ]
              });
            })
            .finally(() => {
              clearTimeout(timeout);
              this.loading = false;
            });
        }
      },
      remove: () => {
        this.$modal.show("dialog", {
          text: this.$store.getters.TRANSLATIONS["are_you_sure"],
          buttons: [
            {
              title: this.$store.getters.TRANSLATIONS["no"]
            },
            {
              title: this.$store.getters.TRANSLATIONS["yes"],
              handler: () => {
                const timeout = setTimeout(() => {
                  this.loading = true;
                }, 0);
                this.$http
                  .delete(
                    `${process.env.SERVER_URL}/8213C396DE4511EA87D00242AC130003/${this.$store.getters.USER.selectedCar.id}`,
                    {
                      headers: {
                        "x-access-token": this.$storage.get("parkendaToken")
                      }
                    }
                  )
                  .then((response) => {
                    console.log("Delete car response");
                    console.log(response);
                    if (
                      response.data &&
                      response.status &&
                      response.status === 200
                    ) {
                      this.$router.push("/carsList");
                    }
                  })
                  .catch((error) => {
                    let text =
                      this.$store.getters.TRANSLATIONS["something_went_wrong"];
                    if (
                      error.response &&
                      error.response.data &&
                      error.response.data.error
                    ) {
                      text = error.response.data.error;
                    }
                    this.$modal.show("dialog", {
                      text,
                      buttons: [
                        {
                          title: "OK",
                          handler: () => {
                            this.$router.push("/carsList");
                          }
                        }
                      ]
                    });
                  })
                  .finally(() => {
                    clearTimeout(timeout);
                    this.loading = false;
                  });
              }
            }
          ]
        });
      },
      addDoorJam: () => {
        this.$router.push("/addDoorJam?returnTo=carEdit");
      },
      myOptions: {
        layout: {
          color: "black",
          backgroundColor: "lightgray",
          selectedColor: "white",
          selectedBackgroundColor: "green",
          borderColor: "black",
          fontWeightSelected: "bold",
          squareCorners: false,
          noBorder: false
        },
        size: {
          fontSize: 0.7,
          height: 2.25,
          width: 20
        },
        items: {
          delay: 0.05,
          preSelected: this.$store.getters.USER.selectedCar.flagIsManual
            ? this.$store.getters.TRANSLATIONS["manual"]
            : this.$store.getters.TRANSLATIONS["automatic"],
          disabled: false,
          labels: [
            {
              name: this.$store.getters.TRANSLATIONS["automatic"],
              color: "white",
              backgroundColor: "#fbae31"
            },
            {
              name: this.$store.getters.TRANSLATIONS["manual"],
              color: "white",
              backgroundColor: "#fbae31"
            }
          ]
        }
      }
    };
  },
  methods: {
    validateYear: (year) => {
      var text = /^[0-9]+$/;
      if (year != 0) {
        if (year != "" && !text.test(year)) {
          return this.$store.getters.TRANSLATIONS["please_enter_numeric"];
        }

        if (year.length != 4) {
          return this.$store.getters.TRANSLATIONS["year_is_not_proper"];
        }
        var current_year = new Date().getFullYear();
        if (year < 1900 || year > current_year) {
          return this.$store.getters.TRANSLATIONS["year_should_be_in_range"];
        }
        return;
      }
    }
  }
};
</script>

<style src="../../styles/main.css"></style>
<style scoped>
.content {
  justify-content: center;
}
input {
  width: 60%;
  background: transparent !important;
  color: rgba(114, 174, 255, 1) !important;
  border: 0;
  outline: 0;
  border-bottom: 1px solid rgba(114, 174, 255, 1);
}

select {
  width: 60%;
  background: transparent;
  color: rgba(114, 174, 255, 1);
  border: 0;
  outline: 0;
  border-bottom: 1px solid rgba(114, 174, 255, 1);
}
.row {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.item {
  margin: 5px auto;
  width: 50%;
}
.remove {
  margin: 1vh auto;
  background-color: white;
  color: #fbae31;
}
.doorjam {
  margin: 1vh auto;
  background-color: rgba(114, 174, 255, 1);
  color: #ffffff;
}
.save {
  margin: 1vh auto;
}
.footer {
  height: 30vh;
}
.transmission {
  margin-top: auto;
  margin-bottom: 5vh;
}
.transmission p {
  color: #ffffff;
  margin-bottom: 1vh;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Cars/Edit.vue